import QuantityProduct from './QuantityProduct'

class PanoramaPhotoProduct extends QuantityProduct {}

export default PanoramaPhotoProduct
